import { HttpForm } from "../Support/HttpForm";
import { axios } from "../Support/Axios";
export class Order extends HttpForm {
    data;
    campaign;
    product = false;
    prefilledValues = [
        '25.00',
        '50.00',
        '100.00'
    ];
    constructor(campaign, product, redemption) {
        super();
        this.campaign = campaign;
        this.product = product;
        if (this.product.denominations) {
            let denominations = [];
            for (let i = 0; i < this.product.denominations.length; i++) {
                let value = Number(this.product.denominations[i]);
                let v = value / 100;
                denominations.push(v);
            }
            this.prefilledValues = denominations;
        }
        this.data = {
            code: redemption.code ?? '',
            order_currency: product.currency,
            name: redemption.name ?? '',
            email: redemption.email ?? '',
            sku: product.sku,
            value: null,
            email_to_customer: true,
        };
    }
    create() {
        const url = '/api/redeem/campaign/' + this.campaign.slug + '/order/create';
        this.resetErrorStatus();
        return new Promise(resolve => {
            axios.post(url, this.data)
                .then((response) => {
                resolve(response.data.data.slug);
            })
                .catch(e => this.setError(e));
        });
    }
    valueInput() {
        return this.data.value !== null;
    }
    productSelected() {
        return this.product !== false;
    }
    selectPrefillValue(value) {
        this.data.value = value;
    }
}
